module.exports = __webpack_public_path__ + "img/header-products-mobile.3cfb112.png";